// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.miniworkflow.MiniWorkflowQueueWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData } from '@zg-rentals/ts-leasing-client';

import type {
  SubmitMiniWorkflowDataWebApiRequestDto,
  SubmitMiniWorkflowDataWebApiResponseDto,
} from '@zg-rentals/ts-leasing-client';

export interface MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData_Args {
  postData: SubmitMiniWorkflowDataWebApiRequestDto;
}

export type MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData_Options = UseMutationOptions<
  SubmitMiniWorkflowDataWebApiResponseDto,
  unknown,
  MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData_Args
>;

/**
 * add data when in the context of a mini workflow
 */
export const useMiniWorkflowQueueWebApiHandler_submitMiniWorkflowData = ({
  httpClient,
  ...options
}: Omit<MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData_Args) =>
      MiniWorkflowQueueWebApiHandler_submitMiniWorkflowData(args.postData, httpClient),
  });
};
